import React from 'react';
import getConfig from 'next/config';
import SkipLink from '@domain-group/fe-co-skip-link';

import { GetServerSideProps } from 'next';
import {
  ErrorBoundary,
  LandingPage,
  LandingPageHead,
  LandingPageHeader,
  LandingPageFooter,
} from '../../components';
import { skipLinkName } from '../../helper/accessibility-utils';
import { AppPageProps } from '../_app';
import { getUserDetails } from '../../utils';
import { UserDetailsRedacted } from '../../@types';

const { publicRuntimeConfig } = getConfig();

interface Props extends AppPageProps {
  user: UserDetailsRedacted;
  isEmbeddedApp: boolean;
  mixpanelHasInitialized?: boolean;
  serverReferer?: string;
}

const FindAnAgentLandingPage = ({
  user,
  isEmbeddedApp = false,
  mixpanelHasInitialized = false,
  serverReferer,
}: Props): JSX.Element => {
  const breadcrumbs = [
    {
      title: 'Real Estate Agents',
      url: `${publicRuntimeConfig.BASE_URL}/real-estate-agents/`,
    },
  ];

  return (
    <ErrorBoundary>
      <>
        <LandingPageHead breadcrumbsData={breadcrumbs} user={user} />
        <SkipLink anchorName={skipLinkName} />
        {isEmbeddedApp ? null : (
          <LandingPageHeader breadcrumbsData={breadcrumbs} />
        )}
        <LandingPage
          skipLinkContentId={skipLinkName}
          mixpanelHasInitialized={mixpanelHasInitialized}
          serverReferer={serverReferer}
        />
        {isEmbeddedApp ? null : <LandingPageFooter />}
      </>
    </ErrorBoundary>
  );
};

export default FindAnAgentLandingPage;

export const getServerSideProps: GetServerSideProps<Props> = async ({
  req,
  res,
}) => {
  const user = getUserDetails(req.user);

  const props = {
    // _app.js props
    serverInfo: res.locals.serverInfo,
    mixpanelToken: publicRuntimeConfig.MIXPANEL_TOKEN,

    // User data
    user,

    // page props
    isEmbeddedApp: req.isEmbeddedApp,
    serverReferer: req.headers.referer || undefined,
  };

  return JSON.parse(
    JSON.stringify({
      props,
    }),
  );
};
